import React from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import SingleItemPage from "./SingleItemPage";

function ImageGalleryMobile(props) {
  const { t } = useTranslation();

  const getBannerData = () => {
    const availableImages = props.images || [];
    const title = props.data?.order_title || props.order_title || "Varathane";
    const brand = props.data?.brand_name || props.order_brand_name || "PREMIUM FAST DRY WOOD STAIN";
    const sku = props.data?.sku || "SKU12345";
    const price = props.data?.price_after_discount ? 
      `${props.data.currency} ${props.data.price_after_discount}` : 
      "$24.99";

    return [
      // First Banner
      {
        title: title,
        subtitle: brand,
        description: "",
        bgColor: "#fff",
        accentPosition: "bottom-right",
        imagePos: "left",
        textPos: "right",
        textColor: "#333",
        transparentImage: true
      },
      // Second Banner
      {
        title: title,
        subtitle: `SKU: ${sku}`,
        price: price,
        description: "",
        bgColor: "#fff",
        accentPosition: availableImages[1] ? "bottom-left-large" : "full-brown",
        imagePos: "right",
        textPos: "left",
        textColor: availableImages[1] ? "#fff" : "#fff",
        transparentImage: true
      },
      // Third Banner
      {
        title: "",
        subtitle: "",
        description: "No artificial paint can mimic the beauty of natural wood. The Varathane Premium Fast Dry Wood Stain helps you accentuate the colour, clarity and highlight wood grains.",
        bgColor: "#fff",
        accentPosition: availableImages[2] ? "right-full-brown" : "full-brown",
        imagePos: "left-full",
        textPos: "right",
        textColor: "#fff",
        transparentImage: false
      },
      // Fourth Banner
      {
        title: "Premium Quality Assurance",
        subtitle: "",
        description: "Our products undergo rigorous quality testing to ensure durability and performance. Made with premium materials for exceptional results every time.",
        bgColor: "#fff",
        accentPosition: "top-left-bottom-right",
        imagePos: "right-contained",
        textPos: "left",
        textColor: "#666",
        transparentImage: true
      }
    ].map((banner, index) => ({
      ...banner,
      image: availableImages[index] || null
    }));
  };

  const banners = getBannerData();
  const remainingImages = props.images?.length > 4 ? props.images.slice(4) : [];

  return (
    <div className="image-gallery" style={{ padding: "20px", backgroundColor: "#fff" }}>
      <h6 className={"heading " + (props.language === "en" ? "text-left" : "text-right")}>
        {t("item-detail.product-image-gallery")}
      </h6>

      <div>
        <div style={{ display: "flex", gap: "15px", marginBottom: "15px" }}>
          {banners.slice(0, 2).map((banner, index) => (
            <Banner key={`banner-${index}`} {...banner} />
          ))}
        </div>

        <div style={{ display: "flex", gap: "15px", marginBottom: "20px" }}>
          {banners.slice(2, 4).map((banner, index) => (
            <Banner key={`banner-${index + 2}`} {...banner} />
          ))}
        </div>
      </div>
      <div>
        <SingleItemPage images={props.item?.img}/>
      </div>
      {remainingImages.length > 0 && (
        <div style={{ marginTop: "30px" }}>
          <div style={{
            display: "flex",
            gap: "10px",
            width: "100%"
          }}>
            {remainingImages.map((image, index) => (
              <div key={`additional-${index}`} style={{
                flex: "1 1 0",
                minWidth: 0,
                height: "150px",
                backgroundColor: "#ffff",
                borderRadius: "8px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "0px",
                overflow: "hidden"
              }}>
                <img
                  src={image.img}
                  alt={image.alt || `Product image ${index + 5}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain"
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      )}

      {props.video && (
        <div className="col-12 p-0" style={{ marginTop: "20px" }}>
          <h6 className="heading">{t("item-detail.product-video")}</h6>
          <div
            className="mb-1 innerhtml video-div"
            dangerouslySetInnerHTML={{ __html: props.video }}
          ></div>
        </div>
      )}
    </div>
  );
}

const Banner = ({
  title,
  subtitle,
  description,
  bgColor,
  accentPosition,
  image,
  imagePos,
  textPos,
  textColor,
  transparentImage,
  price
}) => {
  const flexDirection = textPos === "left" ? "row" : "row-reverse";
  const imageFlex = imagePos === "left-full" ? "0 0 50%" : "1";

  const isFirstBanner = accentPosition === "bottom-right";
  const isSecondBanner = accentPosition === "bottom-left-large" || accentPosition === "full-brown";
  const isThirdBanner = accentPosition === "right-full-brown" || accentPosition === "full-brown";
  const isFourthBanner = accentPosition === "top-left-bottom-right";

  return (
    <div style={{
      flex: 1,
      display: "flex",
      flexDirection,
      border: '1px solid #eee',
      borderRadius: "0px",
      overflow: "hidden",
      position: "relative",
      backgroundColor: bgColor,
      minHeight: "250px",
      height: "250px",
      ...(isSecondBanner && !image && {
        background: 'linear-gradient(to right, #8B4513 0%, #8B4513 100%)'
      }),
      ...(isSecondBanner && image && {
        background: 'linear-gradient(to left, #fff 40%, #8B4513 100%)'
      })
    }}>
      {/* Accent elements */}
      {accentPosition === "full-brown" && (
        <div style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "#8B4513",
          zIndex: 1
        }}></div>
      )}
      
      {accentPosition === "bottom-left-large" && (
        <div style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "40%",
          height: "60%",
          zIndex: 1,
          opacity: 0.9
        }}></div>
      )}
      
      {accentPosition === "bottom-right" && (
        <div style={{
          position: "absolute",
          bottom: 0,
          right: 0,
          width: "40%",
          height: "60%",
          zIndex: 1
        }}></div>
      )}
      
      {accentPosition === "right-full-brown" && (
        <div style={{
          position: "absolute",
          top: 0,
          right: 0,
          width: "50%",
          height: "100%",
          backgroundColor: "#8B4513",
          zIndex: 1
        }}></div>
      )}

      {accentPosition === "top-left-bottom-right" && (
        <>
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "180px",
              height: "120px",
              backgroundColor: "#8B4513",
              zIndex: 1,
              clipPath: "path('M 0 0 L 180 0 Q 30 30 0 120 Z')"
            }}
          ></div>
          <div
            style={{
              position: "absolute",
              bottom: 0,
              right: 0,
              width: "140px",
              height: "140px",
              backgroundColor: "#8B4513",
              zIndex: 1,
              clipPath: "path('M 140 140 L 0 140 Q 120 120 150 0 Z')"
            }}
          ></div>
        </>
      )}

      {/* Text Content */}
      <div style={{
        flex: "1",
        padding: isFirstBanner ? "20px 60px 20px 20px" : 
               isSecondBanner ? "60px 20px 20px 40px" :
               isThirdBanner ? "20px 40px 20px 40px" :
               isFourthBanner ? "20px 25px 20px 70px" : "10px 70px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        zIndex: 4,
        position: "relative",
        marginRight: isFourthBanner && textPos === "left" ? "20px" : "0",
        ...(isFirstBanner && {
          alignItems: 'flex-start',
          textAlign: 'left'
        }),
        ...(isSecondBanner && {
          alignItems: 'flex-start',
          textAlign: 'left'
        })
      }}>
        {title && <h1 style={{ 
          fontSize: isFirstBanner ? "18px" : 
                  isSecondBanner ? "18px" : 
                  isFourthBanner ? "16px" : "14px", 
          fontWeight: "bold", 
          color: textColor, 
          marginBottom: "10px",
          ...(isFirstBanner && {
            letterSpacing: '0.5px',
            borderBottom: '2px solid #8B4513',
            paddingBottom: '8px',
            display: 'inline-block'
          }),
          ...(isSecondBanner && {
            letterSpacing: '0.5px'
          })
        }}>{title}</h1>}
        
        {subtitle && <h2 style={{ 
          fontSize: "14px", 
          fontWeight: isFirstBanner ? "600" : "400", 
          color: textColor, 
          marginBottom: description ? "10px" : "10px",
          ...(isFirstBanner && {
            fontStyle: 'normal',
            color: '#555',
            textAlign: 'left',
          })
        }}>{subtitle}</h2>}
        
        {price && <p style={{ 
          fontSize: "18px", 
          fontWeight: "bold",
          color: isSecondBanner && !image ? '#fff' : 'black', 
          lineHeight: "1.5", 
          margin: "0 0",
          ...(isSecondBanner && {
            backgroundColor: image ? '#f5f5f5' : 'transparent',
            padding: '8px 12px',
            borderRadius: '4px',
            display: 'inline-block'
          })
        }}>{price}</p>}
        
        {description && <p style={{ 
          fontSize: "14px", 
          color: textColor, 
          lineHeight: "1.6", 
          margin: 0,
          maxWidth: isFourthBanner ? "90%" : "100%",
          ...(isFirstBanner && {
            fontStyle: 'normal'
          })
        }}>{description}</p>}
      </div>

      {/* Image Container */}
      {image && (
        <div style={{
          flex: imageFlex,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: isFourthBanner ? "20px 20px 40px 20px" : "20px",
          zIndex: 4,
          position: "relative",
          overflow: "hidden",
          marginLeft: isFourthBanner ? "0px" : "10px",
          marginRight: imagePos === "left-full" ? "0px" : "20px",
          backgroundColor: transparentImage ? 'transparent' : '#fff',
          ...(isFirstBanner && {
            paddingRight: '40px'
          }),
          ...(isSecondBanner && {
            paddingLeft: '40px'
          })
        }}>
          <img
            src={image.img}
            alt={image.alt || "Product image"}
            style={{
              width: imagePos === "left-full" ? "100%" : "auto",
              height: imagePos === "left-full" ? "100%" : "200px",
              objectFit: "contain",
              maxWidth: isFourthBanner ? "80%": "100%",
              maxHeight: isFourthBanner ? "80%" : "100%",
              mixBlendMode: transparentImage ? 'multiply' : 'normal',
              ...(isSecondBanner && {
                transform: 'scale(1.05)'
              })
            }}
          />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  width: state.layout.screenWidth,
  language: state.language.language,
});

export default connect(mapStateToProps, null)(ImageGalleryMobile);